<div style="width: 100%">
  <kendo-grid
    [kendoGridBinding]="tfgCampaignDetails"
    [scrollable]="true"
    [resizable]="true"
    [reorderable]="false"
    [sortable]="false"
  >
    <kendo-grid-column [width]="80" field="campaignId" title="Camp. ID">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.campaignId }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="80"
      field="appliedSequence"
      title="Seq"
      [hidden]="!showCampaignTotals"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.appliedSequence }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="170"
      field="campaignVoucherNumber"
      title="Voucher"
      [hidden]="!showCampaignTotals"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.campaignVoucherNumber }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="350"
      field="storeDescription"
      title="Description"
      ><ng-template kendoGridCellTemplate let-dataItem>
        <span style="white-space: break-spaces">
          {{ dataItem.storeDescription }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="showCampaignTotals"
      [width]="80"
      field="campaignStartDate"
      title="Start Date"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.campaignStartDate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="showCampaignTotals"
      [width]="80"
      field="campaignEndDate"
      title="End Date"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.campaignEndDate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="80"
      field="isProductCampaign"
      title="Product Campaign"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.isProductCampaign ? "Yes" : "No" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="!showCampaignTotals"
      [width]="130"
      format="{0:n2}"
      class="td-number"
      field="amountSpend"
      title="Spend"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="!showCampaignTotals"
      [width]="130"
      format="{0:n2}"
      class="td-number"
      field="discountIssued"
      title="Discount"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="!showCampaignTotals"
      [width]="130"
      format="{0:n0}"
      class="td-number"
      field="nrPurchased"
      title="Nr. Purch."
    >
    </kendo-grid-column>



    <kendo-grid-column
    [hidden]="!showCampaignTotals"
      [width]="80"
      field="reserved"
      title="Reserved"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.reserved ? "Yes" : "No" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
    [hidden]="!showCampaignTotals"
      [width]="80"
      field="confirmed"
      title="Confirmed"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.confirmed ? "Yes" : "No" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="!showCampaignTotals"
      [width]="80"
      field="cancelled"
      title="Cancelled"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.cancelled ? "Yes" : "No" }}
      </ng-template>
    </kendo-grid-column>




    <div *kendoGridDetailTemplate="let dataItem">
      <div
        *ngIf="
          (dataItem.productCampaignLines &&
            dataItem.productCampaignLines.length > 0) ||
          (dataItem.globalCampaignLines &&
            dataItem.globalCampaignLines.length > 0)
        "
        style="width: 100%"
      >
        <kendo-grid
          [kendoGridBinding]="
            dataItem.productCampaignLines
              ? dataItem.productCampaignLines
              : dataItem.globalCampaignLines
          "
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="80" field="lineNumber" title="Line"
            ><ng-template kendoGridCellTemplate let-dataItem2>
              <span style="white-space: break-spaces">
                {{ dataItem2.lineNumber }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="120" field="stockCode" title="Stock Code"
            ><ng-template kendoGridCellTemplate let-dataItem2>
              <span style="white-space: break-spaces">
                {{ dataItem2.stockCode }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="100" field="purchaseQty" title="Pur. Qty"
            ><ng-template kendoGridCellTemplate let-dataItem2>
              <div class="td-number">
                {{ dataItem2.purchaseQty | number : "1.0-0" }}
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="100" field="redeemQty" title="Red. Qty"
            ><ng-template kendoGridCellTemplate let-dataItem2>
              <div class="td-number">
                {{ dataItem2.redeemQty | number : "1.0-0" }}
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="unitRsp"
            title="Unit RSP"
          >
          </kendo-grid-column>

          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="purchaseRsp"
            title="Pur. RSP"
          >
          </kendo-grid-column>

          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="totalDiscount"
            title="Total Disc."
          >
          </kendo-grid-column>

          <kendo-grid-column
            [width]="350"
            field="buyersClass"
            title="Buyers Class"
            ><ng-template kendoGridCellTemplate let-dataItem2>
              <!-- <span style="white-space: break-spaces"> -->
              {{ dataItem2.buyersClass }}
              <!-- </span> -->
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
      <div
        *ngIf="dataItem.itemsConfig && dataItem.itemsConfig.length && showCampaignTotals === false > 0"
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        "
      >
        <kendo-grid
          id="items-grid"
          [rowClass]="rowCallback"
          [kendoGridBinding]="dataItem.itemsConfig"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="130" field="itemType" title="Type">
          </kendo-grid-column>
          <kendo-grid-column [width]="130" field="itemLevel" title="Level">
          </kendo-grid-column>
          <kendo-grid-column [width]="130" field="itemCode" title="Code">
          </kendo-grid-column>
          <kendo-grid-column [width]="130" field="itemDesc" title="Description">
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </kendo-grid>
</div>
